/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { View } from "react-native";

import { useSelector } from "react-redux";
import { RootState } from "store/types";

import GraphTabGroup from "./GraphTabGroup";
import GraphPlot from "./GraphPlot";
import GraphSidebar from "./GraphSidebar";
import GraphHeader from "./GraphHeader";

import { MediaQuery } from "UpduoLibrary";
import { DashboardExploreObject } from "..";

export interface GraphViewProps {
  dashboardName: string;
  exploreObject: DashboardExploreObject;
  onChangeFilterSkill: (value: string) => void;
}

export default function GraphView({
  dashboardName,
  exploreObject,
  onChangeFilterSkill,
}: GraphViewProps) {
  const timeSeriesData = useSelector(
    (state: RootState) => state.timeSeriesData
  );
  const fullDataQueryType = useSelector(
    (state: RootState) => state.fullDataQueryType
  );
  const dayRangeStart = useSelector((state: RootState) => state.dayRangeStart);
  const dayRangeEnd = useSelector((state: RootState) => state.dayRangeEnd);
  const [selectedPlotIdArray, setSelectedPlotIdArray] = useState([]);

  const _handleSetDisplayedPlot = (selectedPlotIdArray) => {
    setSelectedPlotIdArray(selectedPlotIdArray);
  };

  // Must do fresh array creation for GraphPlot because of
  // how useEffect does array comparisons
  const mapSelectedPlotIdArray = selectedPlotIdArray.map((value) => value);
  return (
    <View>
      <GraphHeader
        dashboardName={dashboardName}
        exploreObject={exploreObject}
        onChangeFilterSkill={onChangeFilterSkill}
      />
      <View style={{ flexDirection: "row" }}>
        <GraphTabGroup />
        <GraphPlot
          timeSeriesData={timeSeriesData}
          fullDataQueryType={fullDataQueryType}
          dayRangeStart={dayRangeStart!}
          dayRangeEnd={dayRangeEnd!}
          selectedPlotIdArray={mapSelectedPlotIdArray}
        />
        <MediaQuery minWidth={1000}>
          <GraphSidebar
            selectedPlotIdArray={mapSelectedPlotIdArray}
            onSetDisplayedPlot={_handleSetDisplayedPlot}
          />
        </MediaQuery>
      </View>
    </View>
  );
}
